import { useState } from "react";
import { ChevronUp, MessageSquareText } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function FAQAccordion({ isOpen, onToggle, productKey, index }) {
  const { t } = useTranslation();
  return (
    <div className="bg-white dark:bg-white/5 rounded-lg mb-4 shadow-sm hover:shadow-md transition-shadow border-[#555353]/30 border-[1px]">
      <button
        onClick={onToggle}
        className="w-full text-left px-6 py-4 flex items-center gap-4 justify-between focus:outline-none"
      >
        <span className="text-xl font-semibold">
          {t(
            `singleProductPage.${productKey}.faqsSection.faqs.${index}.question`
          )}
        </span>
        <div className="self-start">
          <ChevronUp
            className={`h-6 w-6 text-primary transition-all duration-300 ${
              isOpen ? "rotate-0" : "rotate-180"
            }`}
          />
        </div>
      </button>
      <div
        className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-96 pb-6" : "max-h-0"
        }`}
      >
        <p className="">
          {t(`singleProductPage.${productKey}.faqsSection.faqs.${index}.answer`)}
        </p>
      </div>
    </div>
  );
}

function ProductFaqs({ product, productName }) {
  const [openIndex, setOpenIndex] = useState(0);
  const { t } = useTranslation();
  const productKey = {
    "group-saving": "ikimina",
    "u-save": "uSave",
    crowdfund: "crowdfund",
  }[productName];

  return (
    <div
      className="bg-white dark:bg-defaultBlack dark:text-white py-16"
      id="faqs"
    >
      <div className="container mx-auto px-4 pt-12">
        <h1 className="text-4xl font-bold mb-8">
          {t("singleProductPage.common.faqsSection.title")}
        </h1>
        <div className="w-full md:w-5/6 md:mx-auto lg:w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Left Content - FAQ List */}
            <div>
              <div className="space-y-2">
                {product.faqs.map((faq, index) => (
                  <FAQAccordion
                    key={index}
                    isOpen={index === openIndex}
                    onToggle={() =>
                      setOpenIndex(index === openIndex ? -1 : index)
                    }
                    productKey={productKey}
                    index={index}
                  />
                ))}
              </div>
            </div>

            {/* Right Content - Contact Information */}

            <div className=" flex items-center bg-white dark:bg-white/5 rounded-xl shadow-lg border-[#555353]/30 border-[1px]">
              <div className="p-8 w-full text-center leading-loose">
                <div className="flex items-center justify-center bg-opacity-10 rounded-full mb-6">
                  <MessageSquareText className="w-16 h-16 stroke-[rgb(0,73,69)]" />
                </div>
                <h2 className="text-2xl font-bold mb-4">
                  {t("faqsSection.more.title")}
                </h2>
                <p className="">
                  {t("faqsSection.more.line1.part1")}{" "}
                  <Link
                    to="/help-center"
                    className=" font-bold hover:underline text-blue-600 dark:text-blue-500"
                  >
                    {t("faqsSection.more.line1.part2")}
                  </Link>{" "}
                  {t("faqsSection.more.line1.part3")}{" "}
                </p>
                <p>
                  <a
                    href="tel:+250794776745"
                    className=" font-bold text-blue-600 dark:text-blue-500 hover:underline"
                  >
                    +250 794776745
                  </a>
                  , {t("faqsSection.more.line2")}{" "}
                </p>
                <p>
                  <a
                    href="mailto:info@uplus.rw"
                    className=" font-bold text-blue-600 dark:text-blue-500 hover:underline"
                  >
                    info@uplus.rw
                  </a>{" "}
                  {t("faqsSection.more.line3")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductFaqs;
